import React, { useState } from "react";
import AdminDashboard from "../AdminDashboard";
import { Alert, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { validateEmail } from "../../../CommonMethods";
import { useParams } from "react-router-dom";
import axios from "axios";
import { basicConfig } from "../../../constants";
import { showNotificationG } from "../../../methods/notificationManager";

const SendMail = () => {
  // const location = useLocation();

  const { pk } = useParams();

  // const urlParams = new URLSearchParams(location.search);

  const [loading, setLoading] = useState(false);

  const [showError, setShowError] = useState(false);

  const [formData, setFormData] = useState({
    subject: null,
    message: null,
    recipients: [pk],
  });

  const { subject, message } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  async function sendMail(e) {
    e.preventDefault();
    setLoading(true);

    // await axios
    //   .post(
    //     `${process.env.REACT_APP_API_URL}/users/sendmail/`,
    //     JSON.stringify(formData),
    //     basicConfig
    //   )
    //   .catch((_) => {
    //     setShowError(true);
    //   })
    //   .then((response) => {
    //     if (response && response.status === 200) {
    //       setLoading(false);
    //       // succuss
    //       showNotificationG("Email Sent.");
    //       setFormData({ ...formData, subject: "" });
    //     } else {
    //       setLoading(false);
    //       setShowError(true);
    //     }
    //   });

    setLoading(false);
  }

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>Send Mail</h4>
          </div>

          <div className="admin_content_content">
            <Row>
              <Col sm={6}>
                <Form onSubmit={(e) => sendMail(e)}>
                  {showError && (
                    <Alert
                      variant="danger"
                      onClose={() => {
                        setShowError(false);
                      }}
                      dismissible
                    >
                      <Alert.Heading>Error Sending Mail.</Alert.Heading>
                    </Alert>
                  )}

                  <p>{pk}</p>

                  {!validateEmail(pk) && (
                    <p style={{ color: "red" }}>Invalid Email</p>
                  )}

                  <Form.Group className="mb-3">
                    <Form.Label>Subject </Form.Label>
                    <Form.Control
                      type="text"
                      name="subject"
                      value={subject}
                      onChange={(e) => onChange(e)}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <label htmlFor="message">Message</label>
                    <textarea
                      name="message"
                      className="form-control"
                      value={message}
                      onChange={(e) => onChange(e)}
                      required
                      rows={8}
                    ></textarea>
                  </Form.Group>

                  <Button
                    type="submit"
                    // disabled={loading || !validateEmail(pk)}
                    disabled={true}
                  >
                    {loading ? "SENDING..." : "SEND MAIL"}
                  </Button>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default SendMail;
